import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL } from '../models/api-url.token';
import { IQuestionMachineTranslationIm } from '../question-machine-translation-im.model';
import { IQuestionMachineTranslationStatusVm } from '../question-machine-translation-status-vm.model';

/**
 * /QuestionMachineTranslation: DeepL translation of the questions the ministry catalogue ships without a
 * Ukrainian version. POST starts a run in the background, GET follows it (and says how many questions still
 * lack the translation), DELETE stops it after the current batch.
 */
@Injectable({ providedIn: 'root' })
export class QuestionMachineTranslationService {
  private readonly baseUrl: string;
  constructor(private http: HttpClient, @Inject(API_URL) private apiUrl: string) {
    this.baseUrl = `${this.apiUrl}/QuestionMachineTranslation`;
  }

  /** Status of the run going now, or of the last one since the API started, plus the current counts. */
  get(): Observable<IQuestionMachineTranslationStatusVm> {
    const headers = this.createHeaders();
    return this.http.get<IQuestionMachineTranslationStatusVm>(this.baseUrl, { headers });
  }

  /** Starts a run; 409 when one is already going, 400 when DeepL is not configured. */
  post(im: IQuestionMachineTranslationIm): Observable<IQuestionMachineTranslationStatusVm> {
    const headers = this.createHeaders();
    return this.http.post<IQuestionMachineTranslationStatusVm>(this.baseUrl, im, { headers });
  }

  /** Asks the run to stop after the current batch; the questions done so far stay translated. */
  delete(): Observable<IQuestionMachineTranslationStatusVm> {
    const headers = this.createHeaders();
    return this.http.delete<IQuestionMachineTranslationStatusVm>(this.baseUrl, { headers });
  }

  private createHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    const token = localStorage.getItem('authToken');
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);
    return headers;
  }
}
